<script setup lang="ts">
import { computed } from 'vue'
import MediumModel from '@/components/Interface/Modal/ModelSizes/MediumModel.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useGameStore } from '@/stores/gameStore'

const gameStore = useGameStore()

const error = computed(() => gameStore.modalData)

const tryAgain = () => {
  gameStore.modalType = ''
  window.location.reload()
}

const closeModal = () => {
  gameStore.modalType = ''
}
</script>

<template>
  <MediumModel title="WebGL Error">
    <StandardCard class="p-2" top-padding="0" bottom-padding="0">
      <div class="mb-4">
        <p>Failed to load the galaxy map. Your device might not have a 3d capabilities, wrong drivers. Or in case of mobile devices, not enough memory available.</p>
        <p class="mt-2 text-sm text-red-500">{{ error }}</p>
      </div>
      <div class="mb-4">
        <p>Brave browser has known issues with the technology we use at Ferion. Chrome has the best compatibility then Firefox or Safari.</p>
        <p>If you see this message on mobile, then most likely your mobile phone does not have enough memory available for the browser.</p>
        <p class="mt-2 text-sm text-red-500">{{ error }}</p>
      </div>
      <div class="flex flex-col sm:flex-row gap-3 justify-center">
        <ActionButton @click="tryAgain" color="blue">
          Try Again
        </ActionButton>
        <ActionButton @click="closeModal" color="gray">
          Continue Without Map
        </ActionButton>
      </div>
    </StandardCard>
  </MediumModel>
</template>